module.exports = __webpack_public_path__ + "img/new-curso.c575374b.svg";